@if (loading) {
<p-skeleton #skeleton height="2rem"></p-skeleton>
} @else {
<div class="input" [ngClass]="showIcon ? positionClass : ''">
  @if (showIcon) {
    <i class="pi" [ngClass]="icon"></i>
  }
  <input
    #input
    pInputText
    [attr.id]="inputId"
    [attr.type]="inputType"
    [attr.placeholder]="placeholder"
    [class]="inputClass"
    [(ngModel)]="value"
    [disabled]="disabled"
    [attr.min]="min"
    [attr.max]="max"
    (input)="handleInput($event)" />
  @if (textError) {
  <small class="invalid-message">
    {{ textError }}
  </small>
  }
</div>
}
